module.exports = __webpack_public_path__ + "media/images/games/k2gender/housekeeper-a13d578773d498d2047c3ddb239b813d.png";